export default "__VITE_ASSET__f926600c__"